<template>
  <v-dialog
    v-model="state"
    max-width="550"
    persistent
    content-class="elevation-0"
  >
    <v-card
      fluid
      class="card-container"
    >
      <v-card-title class="tab-header">
        <v-row
          no-gutters
          align="center"
        >
          <v-col class="pa-0">
            <v-icon
              color="#FFF9C4"
              size="32"
            >
              mdi-information-variant-circle-outline
            </v-icon>
            <b class="ml-1 text-center text-header"> อัปโหลดไฟล์ </b>
          </v-col>
          <v-col
            cols="auto"
            sm="auto"
            md="auto"
            class="pa-0"
          >
            <v-btn
              depressed
              icon
              color="#FFF9C4"
              @click="closeModal()"
            >
              <v-icon size="32"> mdi-close </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-actions>
        <v-form
          ref="validForm"
          lazy-validation
        >
          <v-row class="mt-7">
            <v-row>
              <v-file-input
                outlined
                height="36"
                prepend-icon=""
                append-icon="mdi-upload"
                rounded
                color="#3c5693"
                accept=".xlsx, .xls"
                placeholder="กรุณาเลือกไฟล์ Excel เท่านั้น"
                truncate-length="30"
                class="upload-input-file"
                v-model="file"
                clearable
                :rules="[(v) => !!v || 'กรุณาอัปโหลดไฟล์!']"
                required
              ></v-file-input>
            </v-row>
            <v-row
              class="mt-2"
              align="center"
              justify="space-between"
            >
              <v-col
                cols="auto"
                class="mt-n4"
              >
              <v-autocomplete auto-select-first dense outlined rounded hide-details id="roundNameType"  item-text="text"
              item-value="value" :items="listTypeRoundNanme" :style="{width: roundNameType === 'unit' ? '150px' : '210px'}"
              v-model="roundNameType" ></v-autocomplete>
              </v-col>
              <v-col class="pl-5">
                <v-text-field
                  outlined
                  rounded
                  height="36"
                  color="#3c5693"
                  class="input-text"
                  v-model="certificateRound"
                  :rules="[(v) => !!v || 'กรุณากรอกข้อมูล!']"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-row>
        </v-form>
      </v-card-actions>
      <v-card-actions class="pt-7 pb-6">
        <v-row justify="center">
          <v-btn
            height="40"
            depressed
            rounded
            @click="uploadFile()"
            color="rgb(60,86,147)"
            class="confirm-btn"
            :loading="loading"
          >
            ยืนยัน
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from "../EventBus";

export default {
  props: {
    state: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    file: undefined,
    certificateRound: undefined,
    roundNameType: 'round',
    listTypeRoundNanme:[
      { text:'ประกาศนียบัตรชุดที่',value: "round"},
      { text:'ชื่อองค์กร',value: "unit"},
    ],
  }),
  methods: {
    closeModal(data = {}) {
      this.$refs.validForm.reset();
      this.$nextTick(() => {
        this.roundNameType = "round";
      });
      this.$emit("updateUploadGenCertificated", data);
    },
    async uploadFile() {
      if (!this.$refs.validForm.validate()) {
        return;
      }
      this.loading = true;
      let formData = new FormData();
      
      formData.append("file", this.file);
      formData.append("round", this.certificateRound);
      formData.append("round_type", this.roundNameType);
      try {
        const { data } = await this.axios.post(
          `${process.env.VUE_APP_API_URL}/manage/api/v1/import_data`,
          formData,
        {
          headers: {
            "Content-Type": "multipart/form-data; charset=UTF-8",
          },
        }
        );
        if (data["status"]) {
          EventBus.$emit('alert-success', 'บันทึกสำเร็จ');
          this.closeModal({
            name: this.file["name"],
            round_id: this.certificateRound,
          });
        } else {
          const dataErrorArr = Array.isArray(data?.data) ? data.data : [];
          if(dataErrorArr.length) {
            const styleHeaders = `text-align:center; padding:0px 15px;`
            const styleContent = `text-align:center; margin-top:10px; font-size: 16px;`
            let html = `
            <table style="width:100%; margin-top:20px;" border-collapse:collapse;">
              <tr>
                <th style="${styleHeaders}">เลขประจำตัวประชาชน</th>
                <th style="${styleHeaders}">ชื่อ-สกุล</th>
                <th style="${styleHeaders}">เลขที่ประกาศนียบัตร</th>
              </tr>
            `;
            dataErrorArr.forEach(item => {
              html += `
                <tr>
                  <td>
                    <div style="${styleContent}">${item.id_card_num}</div>
                  </td>
                  <td>
                    <div style="${styleContent}">${item.full_name_th}</div>
                  </td>
                  <td>
                    <div style="${styleContent} color:#f44336;">${item.certificated_number}</div>
                  </td>
                </tr>
              `;
            });
            html += `
              </table>
              <div style="text-align:left; margin-top:20px; color:#f44336; font-size: 16px;">*เลขที่ประกาศนียบัตรซ้ำในระบบ</div>
            `;
            this.alertSpecificError(html);
          }
          else throw new Error(data["message"]);
        }
      } catch (error) {
        const errorMsg = error?.message ?? error;
        console.log(errorMsg);
        this.alertError(
          "อัปโหลดไฟล์เข้าสู่ระบบไม่สำเร็จ!<br />กรุณาลองใหม่อีกครั้ง"
        );
      } finally {
        this.loading = false;
      }
    },
    alertError(html = "", timer = 4000) {
      this.$swal({
        icon: "error",
        html,
        showCloseButton: true,
        showConfirmButton: false,
        timer: timer,
        customClass: {
          htmlContainer: "alert-text",
        },
      });
    },
    alertSpecificError(html = "") {
      this.$swal({
        icon: "error",
        html,
        width: "auto",
        heightAuto: true,
        showConfirmButton: true,
        confirmButtonText: "ปิด",
        confirmButtonColor: "#f44336",
        customClass: {
          htmlContainer: "alert-text",
        },
      });
    },
  },
};
</script>

<style scoped>
* {
  color: #000;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: "Noto Sans Thai", sans-serif !important;
}

.row {
  padding: 0;
  margin: 0;
  width: 100% !important;
  box-sizing: border-box !important;
}

.card-container {
  padding: 0;
  border-radius: 18px;
}

.tab-header {
  padding: 8px 12px !important;
  color: #fff9c4;
  background-color: rgb(60, 86, 147);
}

.text-header {
  color: #fff9c4;
}

.upload-input-file >>> .v-input__control > .v-input__slot {
  min-height: auto;
  padding: 0 16px;
  margin-bottom: 4px;
}

.upload-input-file >>> .v-input__control > .v-text-field__details {
  margin-bottom: 0px;
}

.upload-input-file
  >>> .v-input__control
  > .v-input__slot
  > .v-input__append-inner {
  margin: 0;
  padding: 0;
  height: 100%;
  display: flex;
  align-items: center;
}

.input-text >>> .v-input__control > .v-input__slot {
  min-height: auto;
  padding: 0 16px;
  margin-bottom: 4px;
}

.input-text >>> .v-input__control > .v-text-field__details {
  margin-bottom: 0px;
}

.confirm-btn {
  color: #fff;
  font-size: 20px;
  padding: 0 36px !important;
  font-weight: 700;
  letter-spacing: 0.5px;
}

@media only screen and (max-width: 37.5em) {
  .card-text-container {
    padding: 12px !important;
  }
}

@media only screen and (max-width: 25em) {
  .text-header,
  .confirm-btn {
    font-size: 18px;
  }
}
</style>
